import { useContext} from 'react';
import { Grid2 as Grid, Typography, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Link, styled, Paper, useMediaQuery, useTheme, Card, CardContent, Stack} from '@mui/material';
import { FilersDataContext } from '../../Filers';
import IndependentExpenditureReportContent from '../../../../types/reports/independentExpenditureReportContent';

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  }));


const FilerRelatedReports = (): JSX.Element => {

    const theme = useTheme();
    const isSM = useMediaQuery(theme.breakpoints.down('sm'));    

    const filerDataContext = useContext(FilersDataContext);
    const filerRelatedReports = filerDataContext.currentFilerRelatedReports;

    return (
        <Grid container marginBottom={2}>
            <Grid size={{xs:12, md:11}}>
            {
                (filerRelatedReports ?? []).length > 0 && !isSM &&
                <TableContainer component={Paper}>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell><Typography variant='subtitle2' fontWeight={550}>Date</Typography></TableCell>
                                <TableCell><Typography variant='subtitle2' fontWeight={550}>Filing Entity</Typography></TableCell>
                                <TableCell><Typography variant='subtitle2' fontWeight={550}>Amount Spent</Typography></TableCell>
                                <TableCell><Typography variant='subtitle2' fontWeight={550}>Report Type</Typography></TableCell>
                                <TableCell><Typography variant='subtitle2' fontWeight={550}>Candidate(s)</Typography></TableCell>
                                <TableCell><Typography variant='subtitle2' fontWeight={550}>Position</Typography></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                        {
                            filerRelatedReports?.map((report: IndependentExpenditureReportContent) =>
                                <StyledTableRow key={report.reportId}>
                                    <TableCell>
                                        {
                                            report.reportType === 'IEP'?
                                            <Typography variant="body2" component={Link} href={`/reports/displayreport?id=${report.reportId}`} underline='none' target='_blank'>{report.reportingPeriod}</Typography> 
                                            :
                                            <Typography variant="body2" component={Link} href={`/reports/displayreport?id=${report.reportId}&isIE=1`} underline='none' target='_blank'>{report.reportingPeriod}</Typography> 
                                        }
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="body2">{report.filingEntity}</Typography>
                                    </TableCell>
                                    <TableCell width={150} align='right'>
                                        <Typography variant="body2">{report.expenditureTotal}</Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="body2">{report.reportTypeDescription}</Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="body2">{report.candidateListing}</Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="body2">{report.position}</Typography>
                                    </TableCell>
                                </StyledTableRow>
                            )
                        }
                        </TableBody>
                    </Table>
                </TableContainer>
            }
            {
                (filerRelatedReports ?? []).length > 0 && isSM &&
                 filerRelatedReports?.map((report: IndependentExpenditureReportContent) =>
                    <Card variant="outlined" key={report.reportId} sx={{ marginBottom: 2 }}>
                        <CardContent>
                            <Stack spacing={1}>
                                <Typography variant="body2">
                                    <b>Filing Entity: </b>{report.filingEntity}
                                </Typography>
                                {
                                    report.reportType === 'IEP'?
                                    <Stack direction={'row'} spacing={1}>
                                        <Typography variant="body2" color="primary">
                                            <b>Date: </b>
                                        </Typography>
                                        <Typography variant="body2" component={Link} href={`/reports/displayreport?id=${report.reportId}`} underline='none' target='_blank'>{report.reportingPeriod}</Typography> 
                                    </Stack>
                                    :
                                    <Stack direction={'row'} spacing={1}>
                                         <Typography variant="subtitle1" color="primary">
                                            <b>Date: </b>
                                        </Typography>
                                        <Typography variant="body2" component={Link} href={`/reports/displayreport?id=${report.reportId}&isIE=1`} underline='none' target='_blank'>{report.reportingPeriod}</Typography> 
                                    </Stack>
                                }
                                <Typography variant="body2">
                                    <b>Report Type: </b>{report.reportTypeDescription}
                                </Typography>
                                <Typography variant="body2">
                                    <b>Amount: </b>{report.expenditureTotal}
                                </Typography>
                                <Typography variant="body2">
                                    <b>Candidate(s): </b>{report.candidateListing}
                                </Typography>
                                <Typography variant="body2">
                                    <b>Position: </b>{report.position}
                                </Typography>
                            </Stack>
                        </CardContent>
                    </Card>
                )
            }
            </Grid>
        </Grid>
    );
  };

export default FilerRelatedReports;